import { useCartStore } from "../../store/cart-store";
import { useTranslations } from "../../i18n";

/**
 * Étapes du tunnel de checkout panier
 * Panier -> Infos -> Paiement
 */
export const CartBreadcrumb = () => {
  const { currentStep } = useCartStore();
  const { t } = useTranslations();

  const cartSteps = [
    { id: "cart", shortLabel: t.cart.cartBreadcrumb.cart },
    { id: "info", shortLabel: t.cart.cartBreadcrumb.info },
    { id: "payment", shortLabel: t.cart.cartBreadcrumb.payment },
  ] as const;

  // Calculer l'index actif
  let activeIndex = 0;
  if (currentStep === "payment") {
    activeIndex = 2;
  } else if (currentStep === "info") {
    activeIndex = 1;
  } else {
    activeIndex = 0;
  }

  // Cacher le breadcrumb sur l'écran de succès
  if (currentStep === "success") {
    return null;
  }

  return (
    <div className="mb-6 px-1">
      <div className="flex items-center justify-end mb-2">
        <span className="text-xs text-gray-500">
          {t.common.step.replace("{current}", String(activeIndex + 1)).replace("{total}", String(cartSteps.length))}
        </span>
      </div>

      {/* Progress bar with step indicators */}
      <div className="relative">
        <div className="h-1.5 w-full bg-gray-100 rounded-full overflow-hidden">
          <div
            className="h-full bg-brand-600 transition-all duration-500 ease-out"
            style={{
              width: `${(activeIndex / (cartSteps.length - 1)) * 100}%`,
            }}
          />
        </div>

        {/* Step dots */}
        <div className="absolute inset-0 flex justify-between items-center">
          {cartSteps.map((step, index) => (
            <div
              key={step.id}
              className={`w-3 h-3 rounded-full border-2 transition-all duration-300 ${
                index <= activeIndex
                  ? "bg-brand-600 border-brand-600"
                  : "bg-white border-gray-300"
              }`}
              title={step.shortLabel}
            />
          ))}
        </div>
      </div>

      {/* Step labels on larger screens */}
      <div className="hidden sm:flex justify-between mt-2">
        {cartSteps.map((step, index) => (
          <span
            key={step.id}
            className={`text-xs transition-colors ${
              index <= activeIndex
                ? "text-brand-700 font-medium"
                : "text-gray-400"
            } ${index === activeIndex ? "font-semibold" : ""}`}
          >
            {step.shortLabel}
          </span>
        ))}
      </div>
    </div>
  );
};
